export const GLOBAL_MARGIN_HORIZONTAL = 4;
export const HEADER_HEIGHT = 80;

export const CONTACT_US_URL = 'http://www.thesimplycity.net/contact-us';
export const TERMS_URL = 'https://www.thesimplycity.net/terms-of-service';
export const PRIVACY_URL = 'https://www.thesimplycity.net/privacy-policy';
